export const automationSteps = {
  action: 'action',
  trigger: 'trigger',
  condition: 'condition',
}
